module.exports = __webpack_public_path__ + "img/telhado-laje.f29a2a01.png";